export default "__VITE_ASSET__DOHIBNS7__"